import { Box, Stack, TextField, Typography } from '@mui/material';
import React from 'react';
import { Button, Dialog } from '../../../Components/MUIs';
import { FileForm } from '../../../Components/FileForm';

function M_TBG_BASIC_08(props) {
  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0, mb: 1 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          오늘도 안전한 하루를 위해
        </Typography>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          회의 내용을 입력해주세요.
        </Typography>
      </Stack>
      <Box sx={{ p: 2 }}>
        <Box
          sx={{
            p: 2,
            py: 4,
            border: 1,
            borderColor: '#F3F4F6',
            borderRadius: 4,
            backgroundColor: '#fff',
            boxShadow: 0,
          }}
        >
          <Typography fontWeight="bold" mb={1}>
            제목{' '}
            <Typography component="span" sx={{ color: 'red' }}>
              *
            </Typography>
          </Typography>
          <TextField
            fullWidth
            size="small"
            placeholder="제목을 입력해주세요."
            value={props.inputs.tbmTitle}
            onChange={(e) =>
              props.setInputs((preState) => ({
                ...preState,
                tbmTitle: e.target.value,
              }))
            }
            error={!props.inputs.tbmTitle}
            helperText={
              !props.inputs.tbmTitle ? '제목은 필수 항목입니다.' : ' '
            }
            sx={
              !props.inputs.tbmTitle
                ? {
                    mb: 2,
                    '& .MuiFormHelperText-root': {
                      margin: 0,
                      color: 'rgb(255, 102, 102)', // 16진법 코드가 안먹어서 rgb코드로 변경(mui 자체 버그인지 적용이안됨;)
                      fontSize: '14px',
                    },
                    '& label.Mui-focused': {
                      color: '#FF6666',
                    },
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused fieldset': {
                        borderColor: '#FF6666',
                      },
                      '&.Mui-error fieldset': {
                        borderColor: '#FF6666',
                      },
                    },
                  }
                : {
                    mb: 2,
                    '& .MuiFormHelperText-root': {
                      margin: 0,
                      fontSize: '14px',
                    },
                  }
            }
          />
          <Typography fontWeight="bold" mb={1}>
            장소{' '}
            <Typography component="span" sx={{ color: 'red' }}>
              *
            </Typography>
          </Typography>
          <TextField
            fullWidth
            size="small"
            placeholder="장소를 입력해주세요."
            value={props.inputs.tbmAddress}
            onChange={(e) =>
              props.setInputs((preState) => ({
                ...preState,
                tbmAddress: e.target.value,
              }))
            }
            error={!props.inputs.tbmAddress}
            helperText={
              !props.inputs.tbmAddress ? '장소는 필수 항목입니다.' : ' '
            }
            sx={
              !props.inputs.tbmAddress
                ? {
                    mb: 2,
                    '& .MuiFormHelperText-root': {
                      margin: 0,
                      color: 'rgb(255, 102, 102)', // 16진법 코드가 안먹어서 rgb코드로 변경(mui 자체 버그인지 적용이안됨;)
                      fontSize: '14px',
                    },
                    '& label.Mui-focused': {
                      color: '#FF6666',
                    },
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused fieldset': {
                        borderColor: '#FF6666',
                      },
                      '&.Mui-error fieldset': {
                        borderColor: '#FF6666',
                      },
                    },
                  }
                : {
                    mb: 2,
                    '& .MuiFormHelperText-root': {
                      margin: 0,
                      fontSize: '14px',
                    },
                  }
            }
          />
          <Typography fontWeight="bold" mb={1}>
            내용{' '}
            <Typography component="span" sx={{ color: 'red' }}>
              *
            </Typography>
          </Typography>
          <TextField
            fullWidth
            size="small"
            placeholder="내용을 입력해주세요."
            value={props.inputs.tbmComment}
            onChange={(e) =>
              props.setInputs((preState) => ({
                ...preState,
                tbmComment: e.target.value,
              }))
            }
            error={!props.inputs.tbmComment}
            helperText={
              !props.inputs.tbmComment ? '내용은 필수 항목입니다.' : ' '
            }
            multiline
            rows={4}
            sx={
              !props.inputs.tbmComment
                ? {
                    mb: 2,
                    '& .MuiFormHelperText-root': {
                      margin: 0,
                      color: 'rgb(255, 102, 102)',
                      fontSize: '14px',
                    },
                    '& label.Mui-focused': {
                      color: '#FF6666',
                    },
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused fieldset': {
                        borderColor: '#FF6666',
                      },
                      '&.Mui-error fieldset': {
                        borderColor: '#FF6666',
                      },
                    },
                  }
                : {
                    mb: 2,
                    '& .MuiFormHelperText-root': {
                      margin: 0,
                      fontSize: '14px',
                    },
                  }
            }
          />
          <Typography fontWeight="bold" mb={1}>
            사진
          </Typography>
          <TextField
            fullWidth
            size="small"
            placeholder="사진을 첨부해주세요."
            value={props.inputs.photoNm}
            readOnly={true}
            tabIndex={true} // 탭 포커스 방지
            inputMode={true} // IOS 키보드 표시 방지
            onClick={() => props.setModalToggle1(true)}
            onFocus={(e) => {
              e.target.blur();
            }} // 포커스 즉시 blur 처리
            sx={{ mb: 4 }}
          />

          <Button
            name="저장"
            variant="contained"
            fullWidth
            onClick={async () => {
              await props.SaveLogic1();
              props.ActiveButton({
                type: 'next',
                content: true,
                step: 5,
              });
            }}
            sx={{
              height: '36px',
              borderRadius: '18px',
              backgroundColor: '#2DB400',
              '&:hover': {
                backgroundColor: '#26a300',
              },
            }}
          />
        </Box>
      </Box>
      {/* 그리드안 사진 설정하기 팝업 창 */}
      {props.modalToggle1 && (
        <Dialog
          title="사진 설정"
          open={props.modalToggle1}
          onClose={(e) => {
            props.setModalToggle1(false);
            props.setImageFile({
              mapFiles: '',
              mapImage: '',
              mapFileName: '',
            });
          }}
          contentSx={{
            display: 'flex',
            flexDirection: 'column',
            height: '40vh',
          }}
          fullWidth
          saveButtonName="선택"
          closeButtonName="닫기"
          useSaveButton={true}
          useSaveAfterClose={true}
          onSave={() => {
            props.setInputs((preState) => ({
              ...preState,
              photoNm: props.imageFile.mapFileName,
              photoImg: props.imageFile.mapImage,
              photoSrc: props.imageFile.mapFiles,
            }));
          }}
          maxWidth="sm"
          content={
            <div
              className="ag-theme-alpine no-scroll"
              style={{ width: '100%', height: '100%' }}
            >
              <FileForm
                datas={[
                  {
                    type: 'file',
                    name: '파일',
                    onChange: (event) => {
                      const fileList = event.target.files;
                      if (Object.keys(fileList).length === 0) return;

                      const file = fileList[0]; // single file upload

                      const reader = new FileReader();
                      reader.readAsDataURL(file);
                      reader.onload = (e) => {
                        fetch(e.target.result)
                          .then((res) => res.blob())
                          .then((blob) => {
                            const image = new File(
                              [blob],
                              `${new Date()
                                .toISOString()
                                .replace(/T/, '')
                                .replace(/\..+/, '')
                                .replace(/-/g, '')
                                .replace(/:/g, '')}.png`,
                              {
                                type: 'image/png',
                              }
                            );

                            props.setImageFile({
                              ...props.imageFile,
                              mapFiles: reader.result,
                              mapImage: image,
                              mapFileName: image.name,
                            });
                          });
                      };
                      reader.onerror = (error) => {
                        console.log(error);
                        // 파일 읽기 중 에러가 발생했을 때 실행될 코드
                      };
                    },
                    buttonName: '파일 업로드',
                  },
                  {
                    name: '파일명',
                    value: !props.imageFile.mapFileName
                      ? props.inputs.photoNm
                      : props.imageFile.mapFileName || '',
                    disabled: true,
                  },
                ]}
              />

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  height: '90%',
                }}
              >
                <img
                  id={'fileId'}
                  src={
                    !props.imageFile.mapFileName
                      ? props.inputs.photoSrc
                      : props.imageFile.mapFiles || ''
                  }
                  style={{ maxWidth: '100%', objectFit: 'cover' }}
                />
              </Box>
            </div>
          }
        />
      )}
    </>
  );
}

export default M_TBG_BASIC_08;
